import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    iconWithTooltip: {
        cursor: 'pointer'
    },
}));

export const TooltipButton = ({
                                title,
                                icon,
                                isEnabled = true,
                                onClick
}) => {
    const classes = useStyles();

    return (<Tooltip className={classes.iconWithTooltip} 
        title={isEnabled ? title : ''}
        onClick={onClick}
        TransitionProps={{ timeout: 500 }}
    >
        {icon}  
    </Tooltip>)
}
